(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lumera-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHeader(header) {
    if (!header || header.dataset.lumHeaderInit) return;
    header.dataset.lumHeaderInit = '1';
    function setH() { document.body.style.setProperty('--header-height', header.offsetHeight + 'px'); }
    setH();
    window.addEventListener('resize', setH, { passive: true });
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    }, { passive: true });
  }
  function initDrawer() {
    var drawer = document.querySelector('[data-lum-drawer]');
    if (!drawer || drawer.dataset.lumDrawerInit) return;
    drawer.dataset.lumDrawerInit = '1';
    var burger = document.querySelector('.lum-nav__burger');
    function open() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('lum-drawer-open'); if (burger) burger.setAttribute('aria-expanded', 'true'); }
    function close() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('lum-drawer-open'); if (burger) burger.setAttribute('aria-expanded', 'false'); }
    document.querySelectorAll('[data-lum-burger]').forEach(function (el) {
      el.addEventListener('click', function () { drawer.classList.contains('is-open') ? close() : open(); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }
  function initLoc() {
    document.querySelectorAll('[data-lum-loc]').forEach(function (sel) {
      if (sel.dataset.lumLocInit) return; sel.dataset.lumLocInit = '1';
      sel.addEventListener('change', function () { if (sel.form) sel.form.submit(); });
    });
  }
  function boot() { document.querySelectorAll('[data-lum-header]').forEach(initHeader); initDrawer(); initLoc(); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumera-main-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initProduct(section) {
    if (section.dataset.lumInit) return;
    section.dataset.lumInit = '1';

    /* ---------- gallery ---------- */
    var stage = section.querySelector('[data-lum-stage]');
    if (stage) {
      var slides = section.querySelectorAll('[data-lum-slide]');
      var thumbs = section.querySelectorAll('[data-lum-thumbs] .lum-thumb');
      var dots = section.querySelectorAll('[data-lum-dots] .lum-dot');
      var cur = 0;
      var n = slides.length;
      function go(i) {
        if (!n) return;
        cur = (i + n) % n;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === cur); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === cur); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === cur); });
        if (thumbs[cur]) thumbs[cur].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      section.querySelectorAll('[data-lum-gal-i]').forEach(function (el) {
        el.addEventListener('click', function () { go(parseInt(el.getAttribute('data-lum-gal-i'), 10)); });
      });
      section.querySelectorAll('[data-lum-gal]').forEach(function (b) {
        b.addEventListener('click', function () { go(cur + (b.getAttribute('data-lum-gal') === 'next' ? 1 : -1)); });
      });
      var x0 = null;
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });
    }

    /* ---------- bundle selector -> variant + price ---------- */
    var bundles = section.querySelectorAll('[data-lum-bundle]');
    var variantInput = section.querySelector('[data-lum-variant-id]');
    var now = section.querySelector('[data-lum-now]');
    var was = section.querySelector('[data-lum-was]');
    var save = section.querySelector('[data-lum-save]');
    var each = section.querySelector('[data-lum-each]');
    var addBtnText = section.querySelector('.lum-add .add-to-cart-text__content span span');
    var baseAddLabel = addBtnText ? addBtnText.textContent.trim() : 'Ajouter au panier';

    function selectBundle(btn) {
      if (btn.classList.contains('is-soldout')) return;
      bundles.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-checked', 'false'); });
      btn.classList.add('is-active');
      btn.setAttribute('aria-checked', 'true');
      if (variantInput) {
        variantInput.value = btn.getAttribute('data-variant-id');
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var d = btn.dataset;
      if (now) now.textContent = d.now || '';
      if (was) was.textContent = d.was || '';
      if (save) { save.textContent = d.save || ''; save.hidden = !d.save; }
      if (each) each.textContent = d.each || '';
      if (addBtnText && d.now) addBtnText.textContent = baseAddLabel + ' — ' + d.now;
    }
    bundles.forEach(function (btn) { btn.addEventListener('click', function () { selectBundle(btn); }); });
    var active = section.querySelector('[data-lum-bundle].is-active');
    if (active && addBtnText && active.dataset.now) addBtnText.textContent = baseAddLabel + ' — ' + active.dataset.now;

    /* ---------- quantity ---------- */
    var qInput = section.querySelector('[data-lum-qty-val]');
    section.querySelectorAll('[data-lum-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qInput) return;
        var v = parseInt(qInput.value, 10) || 1;
        var max = parseInt(qInput.max, 10) || 99;
        v += (b.getAttribute('data-lum-qty') === 'plus' ? 1 : -1);
        if (v < 1) v = 1; if (v > max) v = max;
        qInput.value = v;
      });
    });
  }

  function boot() { document.querySelectorAll('.lum-mp-section').forEach(initProduct); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.lum-mp-section');
    if (s) { s.removeAttribute('data-lum-init'); initProduct(s); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumera-results"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initResults(root) {
    if (!root || root.dataset.lumResInit) return;
    root.dataset.lumResInit = '1';
    var track = root.querySelector('[data-lum-track]');
    var prev = root.querySelector('[data-lum-prev]');
    var next = root.querySelector('[data-lum-next]');
    var dots = root.querySelectorAll('[data-lum-dot]');
    var cards = track ? track.children : [];
    if (!track || cards.length === 0) return;

    function step() {
      return cards.length > 1 ? (cards[1].offsetLeft - cards[0].offsetLeft) : cards[0].getBoundingClientRect().width;
    }
    function index() { return Math.round(track.scrollLeft / step()); }
    function go(i) {
      var n = cards.length;
      i = ((i % n) + n) % n;
      track.scrollTo({ left: step() * i, behavior: 'smooth' });
    }
    function update() {
      var i = index();
      if (dots.length) dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
    }
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (dots.length) dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-lum-dot'), 10)); });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });
    update();
  }
  function boot() { document.querySelectorAll('[data-lum-results]').forEach(initResults); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
